<template>

  <v-container fluid class="page page-delivery-list">

    <!-- Breadcrumb -->
    <v-row class="mt-4 mb-6">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-truck-delivery</v-icon>
        <div>{{ pageTitle }}</div>
      </v-col>
    </v-row>

    <!-- User Setup Guide -->
    <v-row align="center" justify="center">
      <v-col cols="12" xs="12" sm="12" md="10" lg="9">
        <user-app-setup-guide
            :showDeliveryMessage="!showDeliveries && hasRole('admin')"
            :showOrgSetup="hasRole('admin')"
            :showDriverSetup="hasRole('driver')"
            @loaded="checkDeliveryStatus" />
      </v-col>
    </v-row>

    <!-- Delivery List -->
    <template v-if="showDeliveries">
      <!-- Page Navigation -->
      <v-tabs fixed-tabs show-arrows class="page-navigation" v-model="activeTab">
        <v-tab @click="$root.goTo('delivery-list-dispatched')">Dispatched</v-tab>
        <v-tab @click="$root.goTo('delivery-list-on-delivery')">On Delivery</v-tab>
        <v-tab @click="$root.goTo('delivery-list-completed')">Completed</v-tab>
        <v-tab @click="$root.goTo('delivery-list-canceled')">Canceled</v-tab>
      </v-tabs>

      <!-- Page Content -->
      <v-container fluid class="px-0">
        <transition name="fade-flash" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </template>

  </v-container>

</template>

<script>
import UserAppSetupGuide from '@/components/users/UserAppSetupGuide'

export default {
  name: 'DeliveryListRootPage',

  components: {
    UserAppSetupGuide
  },

  data () {
    return {
      activeTab: 0, // delivery-list-dispatched
      showDeliveries: false
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    appName () {
      return this.$store.getters['app/platform']
    },
    activeUser () {
      return this.$store.getters['auth/activeUser']
    },
    activeUserRoles () {
      return this.activeUser.roles
    },
    pageTitle () {
      return (this.hasRole('admin') || this.hasRole('dispatcher'))
        ? 'Deliveries'
        : 'My Deliveries'
    }
  },

  beforeMount () {
    this.setActiveTab()
  },

  watch: {
    '$route.name': {
      handler: 'setActiveTab',
      immediate: true
    }
  },

  methods: {
    setActiveTab () {
      switch (this.$route.name) {
        case 'delivery-list-dispatched': this.activeTab = 0; break
        case 'delivery-list-on-delivery': this.activeTab = 1; break
        case 'delivery-list-completed': this.activeTab = 2; break
        case 'delivery-list-canceled': this.activeTab = 3; break
      }
    },

    hasRole (role) {
      return this.$root.utils.includes(this.activeUserRoles, role)
    },

    checkDeliveryStatus (validated) {
      if (this.hasRole('admin') && validated.org_setup === true) this.showDeliveries = true
      else if (this.hasRole('driver') && validated.driver_setup === true) this.showDeliveries = true
    }
  }
}
</script>

<style scoped>
</style>
